var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChannelManagement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Channel management") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Channel-management",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(4.000000, 6.000000)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "3.875 5.009375 5.75 3.134375 7.625 5.009375"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "7.625 12.509375 5.75 14.384375 3.875 12.509375"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.125,
    y: 0.634375,
    width: 23.75,
    height: 16.25,
    rx: 1.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.375,
    y1: 19.384375,
    x2: 17.625,
    y2: 19.384375,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 17.509375,
    x2: 12,
    y2: 19.071875,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.375,
    y1: 12.509375,
    x2: 20.125,
    y2: 12.509375,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.375,
    y1: 8.759375,
    x2: 20.125,
    y2: 8.759375,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.375,
    y1: 5.009375,
    x2: 20.125,
    y2: 5.009375,
    id: "Path"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelManagement);
export default __webpack_public_path__ + "static/media/channel-management.50be774abcdd96af847c415a3dbd5cd1.svg";
export { ForwardRef as ReactComponent };